<template>
  <div class="noprint" :class="position">
    <label
      for="nav-toggle"
      class="nav-toggle in-flow"
      @click="onToggleMenu"
      v-if="position === 'in-flow'"
    >
      <font-awesome-icon
        :icon="userIcon"
        v-if="!showMenu"
      />
      <span v-if="authTitle && !user">{{ authTitle }}</span>
      <span v-if="authTitle && user">{{ fullName }}</span>
    </label>
    <input type="checkbox" id="nav-toggle" hidden :checked="showMenu">

    <nav class="octobus__nav">
      <label
        for="nav-toggle"
        class="nav-toggle"
        :class="{ 'menu-hide': !showMenu }"
        @click="onToggleMenu"
        v-if="position === 'out-of-flow' || position === 'in-flow' && showMenu"
      >
        <font-awesome-icon
          :icon="userIcon"
          v-if="!showMenu"
        />
      </label>

      <ul class="octobus__has-login" v-if="!user">
        <li @click="onShow('signin')">
          <p class="octobus__menu-item">
            <span>
              <font-awesome-icon
                :icon="signInIcon"
              />
            </span>
            <span>{{ $t('auth.signin.title') }}</span>
          </p>
        </li>
        <li @click="onShow('signup')">
          <p class="octobus__menu-item">
            <span>
              <font-awesome-icon
                :icon="registerIcon"
              />
            </span>
            <span>{{ $t('auth.signup.title') }}</span>
          </p>
        </li>
        <Signin
          v-if="showModal === 'signin'"
          :show="showModal === 'signin'"
          @hideModal="onHide"
          @signin="onSignin"
          @show="onShow('recovery')"
        />
        <Signup v-if="showModal === 'signup'" :show="showModal === 'signup'" @hideModal="onHide" />
        <Recovery v-if="showModal === 'recovery'" :show="showModal === 'recovery'" @hideModal="onHide" />
      </ul>
      <div class="octobus__user-title" v-if="user">
        <p class="octobus__menu-item">
          <span>
            <font-awesome-icon
              :icon="userIcon"
            />
          </span>
          <span>{{ fullName }}</span>
        </p>
      </div>
      <hr class="octobus__dropdown-divider" v-if="user">
      <ul class="octobus__has-user" v-if="user">
        <li>
          <p class="octobus__menu-item" @click="onProfile">
            <span>
              <font-awesome-icon
                :icon="userEditIcon"
              />
            </span>
            <span>{{ $t('auth.userMenu.profile') }}</span>
          </p>
        </li>
        <li>
          <p class="octobus__menu-item" @click="onTickets">
            <span>
              <font-awesome-icon
                :icon="ticketIcon"
              />
            </span>
            <span>{{ $t('auth.userMenu.tickets') }}</span>
          </p>
        </li>
        <!-- <li><router-link :to="{ path: '/' }">{{ $t('auth.userMenu.discount') }}</router-link></li> -->
        <li>
          <p class="octobus__menu-item" @click="onLogout">
            <span>
              <font-awesome-icon
                :icon="signOutIcon"
              />
            </span>
            <span>{{ $t('auth.userMenu.exit') }}</span>
          </p>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faUser, faTicketAlt, faUserEdit, faSignOutAlt, faSignInAlt, faAddressCard } from '@fortawesome/fontawesome-free-solid';
import { b64EncodeUnicode } from '@/utils/utils';
import pick from 'lodash/pick';
import Signin from './Signin';
import Signup from './Signup';
import Recovery from './Recovery';

export default {
  name: 'Authentication',
  components: {
    Signin,
    Signup,
    Recovery,
    FontAwesomeIcon,
  },
  data() {
    return {
      showModal: '',
      user: null,
      showMenu: false,
      position: '',
    };
  },
  methods: {
    onShow(modal) {
      this.showModal = modal;
    },
    onHide() {
      this.showModal = '';
      this.showMenu = false;
    },
    onToggleMenu() {
      this.showMenu = !this.showMenu;
    },
    onSignin(res) {
      const persistedUserData = pick(res, ['id', 'buyerToken', 'buyerTokenExpiresAt']);
      localStorage.setItem('__octobus-user', b64EncodeUnicode(JSON.stringify(persistedUserData)));

      this.user = res;
      this.$EventBus.$userData = res;
      this.$EventBus.$emit('auth__signin', this.user);
    },
    onLogout() {
      localStorage.removeItem('__octobus-user');
      this.user = null;
      this.$EventBus.$emit('auth__logout');
      this.showMenu = false;
    },
    onProfile() {
      this.$EventBus.$emit('auth__profile', this.user);
      this.showMenu = false;
    },
    onTickets() {
      this.$EventBus.$emit('auth__tickets', this.user);
      this.showMenu = false;
    },
  },
  computed: {
    shortName() {
      const { name, surname } = this.user;

      return `${name[0]}${surname[0]}`;
    },
    fullName() {
      const { name, surname } = this.user;

      return `${name} ${surname}`;
    },
    isFullWidth() {
      return this.$fullwidth;
    },
    authTitle() {
      return this.$authTitle;
    },
    userIcon() {
      return faUser;
    },
    ticketIcon() {
      return faTicketAlt;
    },
    userEditIcon() {
      return faUserEdit;
    },
    signOutIcon() {
      return faSignOutAlt;
    },
    signInIcon() {
      return faSignInAlt;
    },
    registerIcon() {
      return faAddressCard;
    },
  },
  mounted() {
    this.user = this.$userData || this.$EventBus.$userData || null;
    this.position = this.$position;

    this.$EventBus.$on('auth__session_expired', () => {
      this.onLogout();
      this.onShow('signin');
    });
  },
};
</script>

<style lang="scss" scoped>
.octobus__avatar {
  color: #fff;
  margin: 10px;
  background-color: #673ab7;
  width: 40px;
  height: 40px;
  display: flex;
  position: relative;
  overflow: hidden;
  font-size: 1.25rem;
  flex-shrink: 0;
  align-items: center;
  user-select: none;
  border-radius: 50%;
  justify-content: center;
  cursor: pointer;
}

.octobus__dropdown-item {
  cursor: pointer;
}

// left menu

label.in-flow {
  position: relative;
  left: auto;
  top: auto;
}

.octobus__nav {
  width: 320px;
  min-width: 320px;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  margin: 0;
  left: -320px;
  padding: 15px 20px;
  -webkit-transition: left 0.3s;
  -moz-transition: left 0.3s;
  transition: left 0.3s;
  background: #16a085;
  z-index: 2000;

  .octobus__user-title {
    margin-top: 0.7rem;
    margin-bottom: 1.1rem;

    .octobus__menu-item {
      color: #fff;
      cursor: default;
    }
  }

  .octobus__has-login {
    margin-top: 0.3rem;
  }

  .octobus__menu-item {
    color: #e2e2e2;
    cursor: pointer;
    transition: color .5s;

    &:hover {
      color: #fff;
      transition: color .5s;
    }
  }
}

.nav-toggle {
    /* абсолютно позиционируем */
    position: absolute;
    /* относительно левого края панели */
    left: 320px;
    /* отступ от верхнего края панели */
    top: 1em;
    /* внутренние отступы */
    padding: 0.5em;
    /* определяем цвет фона переключателя
     * чаще вчего в соответствии с цветом фона панели
    */
    background: inherit;
    /* цвет текста */
    color: #dadada;
    /* вид курсора */
    cursor: pointer;
    /* размер шрифта */
    font-size: 1.2em;
    line-height: 1;
    /* всегда поверх других элементов страницы */
    z-index: 40;
    /* анимируем цвет текста при наведении */
    -webkit-transition: color .25s ease-in-out;
    -moz-transition: color .25s ease-in-out;
    transition: color .25s ease-in-out;
}

.nav-toggle:hover {
    // color: #f4f4f4;
}

[id='nav-toggle'] {
    position: absolute;
    display: none;
}

[id='nav-toggle']:checked ~ .octobus__nav > .nav-toggle {
    width: initial;
    left: auto;
    right: 2px;
    top: 1em;
}

[id='nav-toggle']:checked ~ .octobus__nav {
    left: 0;
    box-shadow:4px 0px 20px 0px rgba(0,0,0, 0.5);
    -moz-box-shadow:4px 0px 20px 0px rgba(0,0,0, 0.5);
    -webkit-box-shadow:4px 0px 20px 0px rgba(0,0,0, 0.5);
    overflow-y: auto;
}

[id='nav-toggle']:checked ~ main > article {
    -webkit-transform: translateX(320px);
    -moz-transform: translateX(320px);
    transform: translateX(320px);
}

[id='nav-toggle']:checked ~ .octobus__nav > .nav-toggle:after {
    content: '\2715';
}

body {
    -webkit-animation: bugfix infinite 1s;
}

@-webkit-keyframes bugfix {
    to {
      padding: 0;
    }
}

@media screen and (min-width: 320px) {
    html,
    body {
      margin: 0;
      overflow-x: hidden;
    }
}

@media screen and (max-width: 320px) {
    html,
    body {
      margin: 0;
      overflow-x: hidden;
    }
    .octobus__nav {
      // width: 100%;
      box-shadow: none
    }
}

.octobus__nav h2 {
    width: 90%;
    padding: 0;
    margin: 10px 0;
    text-align: center;
    text-shadow: rgba(255, 255, 255, .1) -1px -1px 1px, rgba(0, 0, 0, .5) 1px 1px 1px;
    font-size: 1.3em;
    line-height: 1.3em;
    opacity: 0;
    transform: scale(0.1, 0.1);
    -ms-transform: scale(0.1, 0.1);
    -moz-transform: scale(0.1, 0.1);
    -webkit-transform: scale(0.1, 0.1);
    transform-origin: 0% 0%;
    -ms-transform-origin: 0% 0%;
    -moz-transform-origin: 0% 0%;
    -webkit-transform-origin: 0% 0%;
    transition: opacity 0.8s, transform 0.8s;
    -ms-transition: opacity 0.8s, -ms-transform 0.8s;
    -moz-transition: opacity 0.8s, -moz-transform 0.8s;
    -webkit-transition: opacity 0.8s, -webkit-transform 0.8s;
}

.octobus__nav h2 a {
    color: #dadada;
    text-decoration: none;
    text-transform: uppercase;
}

[id='nav-toggle']:checked ~ .octobus__nav h2 {
    opacity: 1;
    transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
}

.octobus__nav > ul {
    display: block;
    margin: 0;
    padding: 0;
    list-style: none;
}

.octobus__nav > ul > li {
    line-height: 2.5;
    opacity: 0;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    -webkit-transition: opacity .5s .1s, -webkit-transform .5s .1s;
    -moz-transition: opacity .5s .1s, -moz-transform .5s .1s;
    -ms-transition: opacity .5s .1s, -ms-transform .5s .1s;
    transition: opacity .5s .1s, transform .5s .1s;
}

[id='nav-toggle']:checked ~ .octobus__nav > ul > li {
    opacity: 1;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
}

.octobus__nav > ul > li:nth-child(2) {
    -webkit-transition: opacity .5s .2s, -webkit-transform .5s .2s;
    transition: opacity .5s .2s, transform .5s .2s;
}

.octobus__nav > ul > li:nth-child(3) {
    -webkit-transition: opacity .5s .3s, -webkit-transform .5s .3s;
    transition: opacity .5s .3s, transform .5s .3s;
}

.octobus__nav > ul > li:nth-child(4) {
    -webkit-transition: opacity .5s .4s, -webkit-transform .5s .4s;
    transition: opacity .5s .4s, transform .5s .4s;
}

.octobus__nav > ul > li:nth-child(5) {
    -webkit-transition: opacity .5s .5s, -webkit-transform .5s .5s;
    transition: opacity .5s .5s, transform .5s .5s;
}

.octobus__nav > ul > li:nth-child(6) {
    -webkit-transition: opacity .5s .6s, -webkit-transform .5s .6s;
    transition: opacity .5s .6s, transform .5s .6s;
}

.octobus__nav > ul > li:nth-child(7) {
    -webkit-transition: opacity .5s .7s, -webkit-transform .5s .7s;
    transition: opacity .5s .7s, transform .5s .7s;
}

.octobus__nav > ul > li > a {
    display: inline-block;
    position: relative;
    padding: 0;
    font-family: 'Open Sans', sans-serif;
    font-weight: 300;
    font-size: 1.2em;
    color: #dadada;
    width: 100%;
    text-decoration: none;
    -webkit-transition: color .5s ease, padding .5s ease;
    -moz-transition: color .5s ease, padding .5s ease;
    transition: color .5s ease, padding .5s ease;
}

.octobus__nav > ul > li > a:hover,
.octobus__nav > ul > li > a:focus {
    color: white;
    padding-left: 15px;
}

.octobus__nav > ul > li > a:before {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    bottom: 0;
    height: 1px;
    width: 100%;
    -webkit-transition: width 0s ease;
    transition: width 0s ease;
}

.octobus__nav > ul > li > a:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    height: 1px;
    width: 100%;
    background: #3bc1a0;
    -webkit-transition: width .5s ease;
    transition: width .5s ease;
}

.octobus__nav > ul > li > a:hover:before {
    width: 0%;
    background: #3bc1a0;
    -webkit-transition: width .5s ease;
    transition: width .5s ease;
}

.octobus__nav > ul > li > a:hover:after {
    width: 0%;
    background: transparent;
    -webkit-transition: width 0s ease;
    transition: width 0s ease;
}

</style>



// WEBPACK FOOTER //
// src/components/_common/Authentication.vue